import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  ref: "dataset-name",
  class: "dataset-name"
}
const _hoisted_3 = {
  key: 0,
  class: "far fa-square --select"
}
const _hoisted_4 = {
  key: 1,
  class: "fa fa-check-square --select"
}
const _hoisted_5 = {
  key: 2,
  class: "fa fa-minus-square --select"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { style: {"display":"flex","gap":"10px","align-items":"center","margin-left":"auto"} }
const _hoisted_11 = { class: "dataset-icon" }
const _hoisted_12 = {
  key: 0,
  class: "fa fa-crop crop-icon"
}
const _hoisted_13 = { class: "dataset-icon" }
const _hoisted_14 = { class: "dataset-icon" }
const _hoisted_15 = {
  key: 0,
  ref: "showMenu",
  class: "dataset-options-menu animated-fast"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "manage-dataset-menu-seperator" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "dataset-children"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "children-dashed-border" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dataset_properties_and_logs = _resolveComponent("dataset-properties-and-logs")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "dataset-item",
    id: _ctx.id
  }, [
    _createVNode(_component_imdex_dialog, {
      width: "1100",
      value: _ctx.datasetPropertiesOpen,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datasetPropertiesOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dataset_properties_and_logs, {
          id: _ctx.id,
          name: _ctx.name,
          datasetType: _ctx.dataType,
          group: _ctx.groupName,
          status: _ctx.status,
          handleCloseCallback: () => (_ctx.datasetPropertiesOpen = false)
        }, null, 8, ["id", "name", "datasetType", "group", "status", "handleCloseCallback"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.visHierarchy.length > 0 && _ctx.searchTerm.length === 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isExpanded = !_ctx.isExpanded), ["stop"])),
            class: _normalizeClass(["fa fa-caret-right", { expanded: _ctx.isExpanded }])
          }, null, 2))
        : _createCommentVNode("", true),
      (
					!_ctx.isDatasetTop ||
					_ctx.status == 'Complete' ||
					(_ctx.status == 'Complete' && _ctx.groupName == '')
				)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.emitSelect()), ["stop"])),
            class: "dataset-checkbox"
          }, [
            (_ctx.selectCheck == 'none')
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.selectCheck == 'all')
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.selectCheck == 'indeterminate')
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onContextmenu: _cache[16] || (_cache[16] = _withModifiers(
					($event) => {
						_ctx.isDatasetTop ? _ctx.toggleShowMenu('right', $event) : null,
							_ctx.highlighted.length > 1 ? _ctx.rightClickEmitHighlight() : _ctx.emitHighlight();
						_ctx.emitSetActiveDatasetType();
						_ctx.emitSetActiveGroup();
					}
				, ["prevent","right","stop","exact"])),
        onClick: [
          _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.emitHighlight()), ["exact","stop"])),
          _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.emitHighlight({ type: 'shift' })), ["shift","stop"]))
        ],
        class: _normalizeClass(["dataset-label", {
					highlighted: _ctx.isHighlighted || _ctx.highlightCheck == 'all'
				}]),
        style: {"display":"flex","align-items":"center","height":"100%","width":"100%"}
      }, [
        (_ctx.dataType != '' && _ctx.groupName != '')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "type-icon",
              src: 
						_ctx.isGAS ? _ctx.$data['ioGAS'] : _ctx.$data[_ctx.dataType.toLowerCase() as keyof typeof $data]
					,
              alt: ""
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.showDatasetNameTruncatedTooltip)
          ? _withDirectives((_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "dataset-n",
              ref: "datasetName",
              onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkShowDsNameTooltip && _ctx.checkShowDsNameTooltip(...args)))
            }, _toDisplayString(_ctx.name), 545)), [
              [_vShow, !_ctx.renaming]
            ])
          : (_openBlock(), _createBlock(_component_imdex_tooltip, {
              key: 2,
              containerStyles: {
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden'
					},
              nudgeX: _ctx.name.length
            }, {
              activator: _withCtx((show) => [
                _withDirectives(_createElementVNode("span", _mergeProps({
                  class: "dataset-n",
                  ref: "datasetName"
                }, _toHandlers(show), {
                  onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkShowDsNameTooltip && _ctx.checkShowDsNameTooltip(...args)))
                }), _toDisplayString(_ctx.name), 17), [
                  [_vShow, !_ctx.renaming]
                ])
              ]),
              tooltip: _withCtx(() => [
                _createElementVNode("span", { innerHTML: _ctx.name }, null, 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["nudgeX"])),
        _withDirectives(_createElementVNode("input", {
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitRenameDataset())),
          onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectRenameText && _ctx.selectRenameText(...args))),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newName) = $event)),
          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.closeRenameInput()), ["enter"])),
          ref: "renameInput",
          type: "text",
          class: "rename-input"
        }, null, 544), [
          [_vModelText, _ctx.newName],
          [_vShow, _ctx.renaming]
        ]),
        _createVNode(_component_imdex_tooltip, {
          nudgeX: _ctx.statusTextWithErrorMsg.length
        }, {
          activator: _withCtx((on) => [
            _createElementVNode("div", _mergeProps({ style: {"display":"flex","align-items":"center"} }, _toHandlers(on)), [
              (_ctx.isDatasetTop && _ctx.status)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"max-width":"34px"},
                    src: 
									_ctx.status == ('Generating Dataset' as DatasetStatus)
										? require(`@/assets/svg/wrench.svg`)
										: _ctx.status == ('Complete' as DatasetStatus)
										? require(`@/assets/svg/cloud-success.svg`)
										: require(`@/assets/svg/error-triangle.svg`)
								
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ], 16)
          ]),
          tooltip: _withCtx(() => [
            _createElementVNode("span", {
              style: {"white-space":"nowrap"},
              innerHTML: _ctx.statusTextWithErrorMsg
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }, 8, ["nudgeX"]),
        (
						_ctx.isDatasetTop && _ctx.status != null
							? _ctx.status == ('Generating Dataset' as DatasetStatus)
							: false
					)
          ? (_openBlock(), _createBlock(_component_imdex_spinner, {
              key: 3,
              size: "1",
              width: "10"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.hasClip)
              ? (_openBlock(), _createElementBlock("i", _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (
								_ctx.activeFiltersForDataset &&
								(_ctx.selectCheck === 'all' || _ctx.selectCheck === 'indeterminate')
							)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filtersIconClicked = true)),
                  class: "fa fa-filter filter-icon"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.isDatasetTop)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  ref: "showMenuIcon",
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => {
								_ctx.toggleShowMenu(), _ctx.emitHighlight();
								_ctx.emitSetActiveDatasetType();
								_ctx.emitSetActiveGroup();
							}, ["stop"])),
                  class: "fa fa-ellipsis-h show-menu-icon"
                }, [
                  _createVNode(_Transition, {
                    enterActiveClass: "zoomIn2",
                    leaveActiveClass: "fadeOutDown"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showMenu)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("ul", null, [
                              (_ctx.groupName === 'BLASTDOG')
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onMousedown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.emitUpdateBlastDogDataset && _ctx.emitUpdateBlastDogDataset(...args)))
                                  }, _toDisplayString(_ctx.$t("ssa.hierarchy.update")), 33))
                                : _createCommentVNode("", true),
                              (_ctx.groupName !== 'BLASTDOG')
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 1,
                                    onMousedown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.emitMoveDataset && _ctx.emitMoveDataset(...args)))
                                  }, _toDisplayString(_ctx.$t("ssa.hierarchy.move")), 33))
                                : _createCommentVNode("", true),
                              (_ctx.highlighted.length == 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onMousedown: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleRename && _ctx.toggleRename(...args)), ["prevent"]))
                                  }, _toDisplayString(_ctx.$t("ssa.hierarchy.rename")), 33))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                onMousedown: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitDeleteDataset(_ctx.name)))
                              }, _toDisplayString(_ctx.$t("ssa.hierarchy.delete")), 33),
                              _hoisted_16,
                              (_ctx.highlighted.length == 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 3,
                                    class: "dataset-properties-menu-item",
                                    onMousedown: _cache[14] || (_cache[14] = ($event: any) => (_ctx.datasetPropertiesOpen = true))
                                  }, _toDisplayString(_ctx.$t("ssa.hierarchy.properties")), 33))
                                : _createCommentVNode("", true)
                            ])
                          ], 512))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ], 34)
    ], 512),
    (_ctx.treeParsed && (_ctx.isExpanded || _ctx.isSearching))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visHierarchy, (hierarchy, i) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent('imdex-dataset'), {
              onDeleteDataset: _cache[19] || (_cache[19] = ($event: any) => (_ctx.emitDeleteDataset($event))),
              onRenameDataset: _cache[20] || (_cache[20] = ($event: any) => (_ctx.emitRenameDataset($event))),
              onMoveDataset: _cache[21] || (_cache[21] = ($event: any) => (_ctx.emitMoveDataset($event))),
              onSelect: _cache[22] || (_cache[22] = ($event: any) => (_ctx.emitSelect($event))),
              key: `${i}${_ctx.name}`,
              id: _ctx.id,
              selected: _ctx.selected,
              highlighted: _ctx.highlighted,
              name: hierarchy.name,
              searchTerm: _ctx.searchTerm,
              isDatasetTop: false,
              tree: hierarchy.tree,
              dataType: _ctx.dataType,
              paraviewVisHierarchies: hierarchy.paraviewVisHierarchies,
              hierarchyDepth: _ctx.hierarchyDepth + 1
            }, null, 40, ["id", "selected", "highlighted", "name", "searchTerm", "tree", "dataType", "paraviewVisHierarchies", "hierarchyDepth"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}